import React from "react";

const Contato = (props) => {
  return (
    <div id="contact" className="container-fluid bg-grey">
      <h2 className="text-center">CONTATO</h2>
      <div className="row">
        <div className="col-sm-5">
          <p>Entre em contato conosco e retornaremos em até 24 horas</p>
          <p>
            <span className="glyphicon glyphicon-map-marker"></span>  Passo
            Fundo, Rio Grande Sul, Rua Gervasio Annes n° 40, Vila Luiza (Rua
            Castanha da Rocha 195, bairro Boqueirão – CEP 99025-080
          </p>
          <p>
            <span className="fab fa-whatsapp"></span>{" "}
            <a
              href="http://api.whatsapp.com/send?1=pt_BR&phone=5554992254132"
              target="_blank"
              rel="noopener noreferrer"
            >
               54- 36015014 E/Ou 54- 992254132 e 54- 91126928
            </a>
          </p>
          <p>
            <span className="glyphicon glyphicon-envelope"></span>{" "}
            <a href="mailto: rondaseguncapf@gmail.com?subject=Contato%20cliente">
               rondaseguncapf@gmail.com
            </a>
          </p>
          <p>
            <span className="fab fa-facebook"></span>{" "}
            <a
              href="https://www.facebook.com/rondamonitoramentopf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </p>
          <p>
            <span className="fab fa-instagram"></span>{" "}
            <a
              href="https://www.instagram.com/gsronda/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

//'fab fa-whatsapp'

/** <p><span className='glyphicon glyphicon-phone'></span> 62 98134-1379</p>
 * <div className='col-sm-7 '>
                    <div className='row'>
                        <div className='col-sm-6 form-group'>
                            <input className='form-control' id='name' name='name' placeholder='Name' type='text' required />
                        </div>
                        <div className='col-sm-6 form-group'>
                            <input className='form-control' id='email' name='email' placeholder='Email' type='email' required />
                        </div>
                    </div>
                    <textarea className='form-control' id='comments' name='comments' placeholder='Comment' rows='5'></textarea><br />
                    <div className='row'>
                        <div className='col-sm-12 form-group'>
                            <button className='btn btn-default pull-right' type='submit'>Send</button>
                        </div>
                    </div>
                </div>
*/

export default Contato;
